import { render, staticRenderFns } from "./previewTopic.vue?vue&type=template&id=3b13c9f0&scoped=true"
import script from "./previewTopic.vue?vue&type=script&lang=js"
export * from "./previewTopic.vue?vue&type=script&lang=js"
import style0 from "./previewTopic.vue?vue&type=style&index=0&id=3b13c9f0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b13c9f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b13c9f0')) {
      api.createRecord('3b13c9f0', component.options)
    } else {
      api.reload('3b13c9f0', component.options)
    }
    module.hot.accept("./previewTopic.vue?vue&type=template&id=3b13c9f0&scoped=true", function () {
      api.rerender('3b13c9f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/testquestion-manage/previewTopic.vue"
export default component.exports